module.exports = __webpack_public_path__ + "img/institut_philippe_pinel.4de0e94d.png";